import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id F031DE59-CC30-47BF-B689-BC993893B03A
 * name checkbox-blank-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-blank-circle.svg
 * tags
 * - Form 
 */
export const CheckboxBlankCircleIcon = createSvgIcon(<><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></>, 'CheckboxBlankCircleIcon');
export default CheckboxBlankCircleIcon